import $axios from '~/plugins/axios';

import { Api, PromoBulk } from '~/api';
import { buildModule } from '../utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedPromoBulks: {} as Dict<PromoBulk>,
	})
	.withGetters({
		storedPromoBulks: state => state.storedPromoBulks,
		byId: state => (id: number): PromoBulk | null => (
			state.storedPromoBulks[id] ?? null
		),
	})
	.withMutations({
		STORE_PROMO_BULK (state, bulk: PromoBulk) {
			state.storedPromoBulks = {
				...state.storedPromoBulks,
				[bulk.id]: bulk,
			};
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			const { data } = await api.get(`/promo-bulk/${ id }`);
			commit('STORE_PROMO_BULK', data.payload);
		},
	});
